import { numericScssVariables } from '../styles/scssVariables';

export type { ScreenSize } from '@libs/utils';
export { getScreenSize } from '@libs/utils';

export const enum Breakpoints {
  Breakpoint599px = 'breakpoint_599_px',
  Breakpoint600px = 'breakpoint_600_px',
  Breakpoint899px = 'breakpoint_899_px',
  Breakpoint900px = 'breakpoint_900_px',
  Breakpoint1199px = 'breakpoint_1199_px',
  Breakpoint1200px = 'breakpoint_1200_px',
  Breakpoint1535px = 'breakpoint_1535_px',
  Breakpoint1536px = 'breakpoint_1536_px',
  Breakpoint2048px = 'breakpoint_2048_px',
  Breakpoint2049px = 'breakpoint_2049_px',
}

const BREAKPOINT_VALUES: Record<Breakpoints, number> = {
  [Breakpoints.Breakpoint599px]: numericScssVariables.breakpoint_599_px,
  [Breakpoints.Breakpoint600px]: numericScssVariables.breakpoint_600_px,
  [Breakpoints.Breakpoint899px]: numericScssVariables.breakpoint_899_px,
  [Breakpoints.Breakpoint900px]: numericScssVariables.breakpoint_900_px,
  [Breakpoints.Breakpoint1199px]: numericScssVariables.breakpoint_1199_px,
  [Breakpoints.Breakpoint1200px]: numericScssVariables.breakpoint_1200_px,
  [Breakpoints.Breakpoint1535px]: numericScssVariables.breakpoint_1535_px,
  [Breakpoints.Breakpoint1536px]: numericScssVariables.breakpoint_1536_px,
  [Breakpoints.Breakpoint2048px]: numericScssVariables.breakpoint_2048_px,
  [Breakpoints.Breakpoint2049px]: numericScssVariables.breakpoint_2049_px,
};

export function isLargerThan(
  curentScreenSize: number,
  breakpiont: Breakpoints
): boolean {
  return curentScreenSize > BREAKPOINT_VALUES[breakpiont];
}

export function isSmallerThan(
  curentScreenSize: number,
  breakpiont: Breakpoints
): boolean {
  return curentScreenSize < BREAKPOINT_VALUES[breakpiont];
}
